module.exports = __webpack_public_path__ + "assets/images/img_ccon.png";